import './Agenda.scss';
import agenda from '../img/program1.png';
import buli from '../img/timeline-final/2020 Ez a kép fekete fehérben mehetne a programmal a buli kifulladásig részhez .jpeg';

import { useI18n } from '../i18n/i18n';

export function Agenda() {
    const t = useI18n();
    return <section id="agenda">
        <img className="bg" src={agenda} alt="" />
        <h1>{t.agenda.title}</h1>
        <div>
            <h2>14:00</h2>
            <p>{t.agenda.church}</p>
            <p style={{ fontSize: '14px', fontStyle: 'italic', fontWeight: '700' }}>{t.agenda.churchPlease}</p>
        </div>
        <div>
            <h2>15:00</h2>
            <p>{t.agenda.welcome}</p>
        </div>
        <div>
            <h2>16:00</h2>
            <p>{t.agenda.ceremony}</p>
            <p>{t.agenda.congratulations}</p>
            <p>{t.agenda.photos}</p>
        </div>
        <div className="smol">
            <h2>{t.agenda.afterCeremony}</h2>
            <p>{t.agenda.creativePhotos}</p>
            <p>-</p>
            <p>{t.agenda.seating}</p>
        </div>
        <div>
            <h2>18:30</h2>
            <p>{t.agenda.dinner}</p>
        </div>
        <div>
            <h2>20:30 / 21:00</h2>
            <p>{t.agenda.firstDance}</p>
        </div>
        <div className="cake">
            <h2>{t.agenda.cake}</h2>
        </div>
        <div>
            <h2>00:00</h2>
            <p>{t.agenda.midnightSnack}</p>
        </div>
        <div className="party">
            <h2>{t.agenda.party1}</h2>
            <div>
                <img src={buli} alt={t.agenda.party1} />
            </div>
            <p>{t.agenda.party2}</p>
        </div>
        <div></div>
        <div>
            <h2>08:00 - 10:00</h2>
            <p>{t.agenda.breakfast}</p>
        </div>
        <div className="divider" />
        <div>
            <h2>2025. 06. 01.</h2>
            <p>{t.agenda.bbq}</p>
        </div>
    </section>
}
